import { useState, useCallback, useRef } from "react";
import { isSeedId } from "@/store/seedTemplates";

interface Template {
  id: string;
  source: string;
  createdAt: number;
  updatedAt: number;
}

export function useBuildSave(
  template: Template | undefined,
  templateSave: (t: Template) => Promise<void>,
) {
  const [buildSaveStatus, setBuildSaveStatus] = useState<"idle" | "saving" | "saved">("idle");
  const saveTimerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const isSeed = template ? isSeedId(template.id) : false;

  const debouncedSave = useCallback(
    (source: string) => {
      if (!template || isSeed) {
        return;
      }
      if (saveTimerRef.current) {
        clearTimeout(saveTimerRef.current);
      }
      saveTimerRef.current = setTimeout(() => {
        void (async () => {
          setBuildSaveStatus("saving");
          try {
            await templateSave({ ...template, source });
            setBuildSaveStatus("saved");
          } catch {
            setBuildSaveStatus("idle");
          }
        })();
      }, 500);
    },
    [templateSave, template, isSeed],
  );

  return { buildSaveStatus, debouncedSave, setBuildSaveStatus };
}
